var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ds-modal", {
    attrs: { open: _vm.showModal },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "modal-dialog go-modal-connect" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "modal-title" }, [
                    _vm._v(
                      _vm._s(_vm.$t("scrap-agent.wordpress.modal-access"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleCloseModal()
                        },
                      },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-form-connect-mode" }, [
                    _c("div", { staticClass: "go-form-header" }, [
                      _c("div", { staticClass: "go-brand" }, [
                        _c("div", { staticClass: "go-brand-symbol" }, [
                          _c("img", {
                            attrs: {
                              alt: "naver blog",
                              src: "https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/wordpress.png",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v("WordPress")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-form-body" }, [
                      _c("dl", { staticClass: "go-block-between" }, [
                        _c("dt", [
                          _c("i", { staticClass: "go-icon-24 go-icon-home" }),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("scrap-agent.wordpress.profile"))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("dd", [
                          _c(
                            "div",
                            { staticClass: "custom-control custom-switch" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.formData.profile,
                                    expression: "formData.profile",
                                  },
                                ],
                                staticClass: "custom-control-input",
                                attrs: {
                                  type: "checkbox",
                                  id: "switchWPProfile",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.formData.profile)
                                    ? _vm._i(_vm.formData.profile, null) > -1
                                    : _vm.formData.profile,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.formData.profile,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.formData,
                                            "profile",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.formData,
                                            "profile",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.formData, "profile", $$c)
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("label", {
                                staticClass: "custom-control-label",
                                attrs: { for: "switchWPProfile" },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("div", { staticClass: "go-block-between" }, [
                          _c(
                            "label",
                            { staticClass: "go-form-label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("scrap-agent.wordpress.input-domain")
                                ) + "\n                    "
                              ),
                              _c(
                                "button",
                                {
                                  staticClass: "btn go-btn-icon",
                                  attrs: {
                                    type: "button",
                                    id: "wordpress-help-url-domain",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "go-icon-20 go-icon-info",
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-popover",
                                {
                                  attrs: {
                                    target: "wordpress-help-url-domain",
                                    triggers: "hover",
                                    placement: "right",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t(
                                          "scrap-agent.wordpress.tooltip-domain"
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "go-input-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.formData.url,
                                expression: "formData.url",
                              },
                            ],
                            staticClass: "go-form-control",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t(
                                "scrap-agent.wordpress.domain-pl"
                              ),
                            },
                            domProps: { value: _vm.formData.url },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.formData,
                                  "url",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _vm.formData.invalidUrl
                          ? _c("div", { staticClass: "go-form-feedback" }, [
                              _c(
                                "div",
                                { staticClass: "go-form-feedback-invalid" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("scrap-agent.wordpress.invalid")
                                    )
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-default",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.$emit("modal:close")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("scrap-agent.back")) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-primary",
                      attrs: { type: "button", disabled: _vm.isDisableBtn },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmitChannel()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("scrap-agent.confirm")) +
                          "\n          "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }